var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / MapElements / POIS / UKSH / Icons / apotheke") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-MapElements-/-POIS-/-UKSH-/-Icons-/-apotheke",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Deutsche_Apotheke_Logo",
    transform: "translate(0.563646, 0.189168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.738041,8.28451946 L17.738041,12.1454165 L14.1786257,12.1608284 L14.1786257,6.21216318 L17.738041,8.28451946 Z M7.28068228,12.2032782 L3.98823016,12.2154904 L3.98823016,19.4191954 L7.29417447,19.4191954 L7.29417447,21.0669482 L5.73415381,20.2883477 L0.00901254379,24.7852437 L8.41242147,28.6216633 L14.1850255,24.4906556 L14.1812392,19.4056501 L17.7418809,19.4068765 L17.7418809,24.4546586 L23.7675822,28.5964919 L27.8663089,22.2705786 L24.5345533,20.0421291 L24.5345533,4.99312044 L16.6617638,0 L7.28068228,4.23057211 L7.28068228,12.2032782 L7.28068228,12.2032782 Z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2902816,4.23766506 L16.6494985,0.00127989073 L24.5217014,4.97642866 L24.5217014,20.048689 L27.8727086,22.2648732 L23.7655559,28.5941464 L17.7328152,24.4644192 L17.7328152,19.4083702 L14.1863585,19.4083702 L14.1863585,24.4810574 L8.42335377,28.6185178 L0,24.7762857 L5.73095422,20.2787495 L7.2902816,21.074735 L7.2902816,19.4083172 L3.98956342,19.4083172 L3.98956342,12.2168239 L7.29033517,12.2168239 L7.29033517,4.23766506 M14.1915313,6.21541635 L14.1915313,12.167975 L17.7328152,12.167975 L17.7328152,8.27614705 L14.1915313,6.21541635 Z",
    id: "path5",
    fill: "#E70317",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.774400ef75b6547a51d5c53654d74594.svg";
export { ForwardRef as ReactComponent };